import { ResponseError } from '../../errors';
import {
  fetchGetConstructorsList,
  TGetConstructorsListRequest,
  TGetConstructorsListResponse,
} from '../../repositories/countryside-constructors/v3/get-constructors-list';
import { IApplicationContext } from '../../types/applicationContext';
import { IBuildersListResponse } from '../../types/builders';

export async function fetchBuildersList(
  { httpApi, logger }: IApplicationContext,
  parameters: TGetConstructorsListRequest,
): Promise<IBuildersListResponse | undefined> {
  try {
    const { response, statusCode }: TGetConstructorsListResponse = await fetchGetConstructorsList({
      httpApi,
      parameters,
    });

    if (statusCode !== 200) {
      throw new ResponseError({
        domain: 'fetchBuildersList',
        message: response.message || 'Неизвестная ошибка',
      });
    }

    return response;
  } catch (error) {
    logger.warning(error, { degradation: 'Список строительных компаний' });

    return undefined;
  }
}
